export default function getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    Array.from({ length: 6 }).forEach(() => {
        color += letters[Math.floor(Math.random() * 16)];
    });
    return color;
}
